import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useError } from 'error-provider/ErrorProvider';
import useFetch from 'hooks/useFetch';
import { Flex, Spinner, Text, Center, Box } from '@chakra-ui/react'; // Import Center
import { PATHS } from '../../router/routes';
const GoogleCalendarOauth = () => {
    const location = useLocation(); // Get location object
    const navigate = useNavigate(); // Get navigate object

    const { showError } = useError();
    const [isAuthorizingGoogle, setIsAuthorizingGoogle] = useState(false); // State for Google Auth loading
    const searchParams = new URLSearchParams(location.search);
    const hasState = searchParams.has('state');
    const hasCode = searchParams.has('code');
    const hasScope = searchParams.has('scope');

    const googleAuthCallbackEndpoint = `${process.env.REACT_APP_SERVER_API_URL}/rest_endpoints/google_calendar_auth_callback`;
    const [
        , // Renamed to avoid conflict if needed later
        { get: getCallbackData, }, // Renamed methods/states
    ] = useFetch<any>(googleAuthCallbackEndpoint);

    useEffect(() => {
        const code = searchParams.get('code');
        const state = searchParams.get('state');
        const scope = searchParams.get('scope');

        const queryString = `code=${encodeURIComponent(code || '')}&state=${encodeURIComponent(
            state || ''
        )}&scope=${encodeURIComponent(scope || '')}`;
        if (!isAuthorizingGoogle) {
            setIsAuthorizingGoogle(true); // Start showing loading state
            getCallbackData(queryString) // Pass only the query string payload
                .then((response) => {
                    console.log('Google Auth Callback Response:', response);

                    if (!response || !response.agent_id) {

                        navigate(`${PATHS.MY_AGENT}?openCalendarSettings=true`);
                    }
                    if (response?.agent_id) {
                        const path = `/${PATHS.AGENT_CONFIGURATION}/${response.agent_id}/${PATHS.AGENT_CONFIGURATION_MORE_SETTINGS}`;
                        navigate(`${path}?openCalendarSettings=true`);
                    }
                    setTimeout(() => {
                        setIsAuthorizingGoogle(false); // Stop showing loading state
                    }, 3000); // Delay for 1 second before stopping loading state
                })
                .catch((error) => {
                    console.error('Google Auth Callback Error:', error);
                    showError('Failed to complete Google Calendar authorization.', error);
                    setIsAuthorizingGoogle(false); // Stop showing loading state
                    // Optionally navigate to an error page or show error message here
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthorizingGoogle, hasState, hasCode, hasScope, searchParams]);

    if (!hasState || !hasCode || !hasScope) {
        return (
            <Center height='100vh'>
                <Box
                    className='mb-4'
                    backgroundColor='white'
                    borderRadius='md'
                    border='1px solid'
                    borderColor='lightgray'
                    p='5'
                >
                    <Text fontSize='lg' color='red.500' textAlign='center' p={4}>
                        Required parameters missing for authorization. Please ensure you initiated the Google Calendar
                        connection correctly.
                    </Text>
                </Box>
            </Center>
        );
    }

    if (isAuthorizingGoogle) {
        return (
            <Center height='100vh'>
                {' '}
                {/* Center content vertically and horizontally */}
                <Flex
                    direction='column'
                    align='center'
                    justify='center'
                    height='200px' // Fixed height for the box
                    width='400px' // Fixed width for the box
                    borderWidth='1px'
                    borderRadius='lg'
                    p={6}
                    boxShadow='md' // Added a subtle shadow
                >
                    <Spinner size='xl' color='blue.500' />
                    <Text mt={4} fontSize='lg' fontWeight='medium'>
                        Authorizing with Google, please wait...
                    </Text>
                </Flex>
            </Center>
        );
    }

    return null; // Or a loading indicator while navigating away
};

export default GoogleCalendarOauth;
